import * as React from 'react';
import { IAuthContext } from 'models/common';
const classNames = require('classnames');
import * as c from 'models/constants';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
require('./style.css');

interface IFollowButtonProps {
	itemType?: string;
	isFollowing: boolean;
	displayFollowerCount?: boolean;
	followerCount?: number;
	fullWidth?: boolean;
	isMyItem?: boolean;
	follow?: () => void;
	unfollow?: () => void;
	context?: IAuthContext;
}

const FollowButtonComponent = (props: IFollowButtonProps) => {
	const { isAuthenticated, signinRedirect } = props.context;
	if (!props.follow && !props.unfollow) {
		return null;
	}
	let labelHoverText: string = null;
	let onClick = (e: React.MouseEvent) => {
		e.stopPropagation();
	};
	const unknownStatus = isAuthenticated() && (props.isFollowing === undefined || props.isFollowing === null);
	if (props.isFollowing) {
		switch (props.itemType) {
			case c.NODE_TYPE_PRODUCT:
			case c.NODE_TYPE_PRODUCT_ITEM_CARD:
				labelHoverText = 'DISLIKE';
				break;
			default:
				labelHoverText = 'UNFOLLOW';
				break;
		}
		if (props.unfollow && !unknownStatus) {
			onClick = (e: React.MouseEvent) => {
				e.stopPropagation();
				if (isAuthenticated()) {
					props.unfollow();
				} else {
					signinRedirect();
				}
			};
		}
	} else {
		switch (props.itemType) {
			case c.NODE_TYPE_PRODUCT:
			case c.NODE_TYPE_PRODUCT_ITEM_CARD:
				labelHoverText = 'LIKE';
				break;
			case c.NODE_TYPE_SHOP:
				labelHoverText = 'FOLLOW THE SHOP';
				break;
			default:
				labelHoverText = 'FOLLOW';
				break;
		}
		if (props.follow && !unknownStatus) {
			onClick = (e: React.MouseEvent) => {
				e.stopPropagation();
				if (isAuthenticated()) {
					props.follow();
				} else {
					signinRedirect();
				}
			};
		}
	}
	const xIcon = <img src={require('../../../containers/Html/icons/glossiq/xxx.svg')} alt="tripple-x button" />;

	return (
		<div
			className={classNames(
				'followButton',
				{ ['following']: props.isFollowing },
				{ ['fullWidth']: props.fullWidth },
				{ ['disabled']: unknownStatus || !onClick },
			)}
			onClick={onClick}
		>
			{props.displayFollowerCount && props.followerCount != null && (
				<div className="followButtonLabel">{props.followerCount} Followers</div>
			)}

			<div className="followButtonHover">
				<p className="marqueeText">
					{props.fullWidth && !props.isFollowing
						? [...Array(30)].map((_, i) => (
								<span className="followTheShop" key={i}>
									{xIcon}
									<span>{labelHoverText}</span>
								</span>
						  ))
						: labelHoverText}
				</p>
			</div>

			<div className="followButtonIcon">
				{props.isFollowing ? (
					<img src={require('../../../containers/Html/icons/glossiq/MX_Green.svg')} alt="mx green" />
				) : (
					<img src={require('../../../containers/Html/icons/glossiq/MX.svg')} alt="mx" />
				)}
			</div>
		</div>
	);
};

const FollowButton = withAuthContext(FollowButtonComponent);

export { FollowButton };
